import React, { useContext, useEffect, useState, forwardRef, useRef, useImperativeHandle, useMemo, useCallback} from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import Form from 'react-bootstrap/Form';
import Skeleton from 'react-loading-skeleton'
import { useTranslation, Trans } from "react-i18next";
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import FormFileUpload from "./../inputs/fileupload";
import FormSelect from './../inputs/select';
import Button from 'react-bootstrap/Button';

import Pagination from 'react-bootstrap/Pagination';
import { useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import ConfirmPopup from './../modal/modal';
import Card from 'react-bootstrap/Card';
import Paginator from './../paginator/paginator';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { defaultPageSize, displayFilter } from './../../utils'
import Table from 'react-bootstrap/Table';
//import ReactScrollPagination from 'react-scroll-pagination'
import NumberFormatted from './../../shared/components/numberFormatted';


import InputGroup from 'react-bootstrap/InputGroup';

import MaterialReactTable, {
    MRT_ShowHideColumnsButton,
    MRT_FullScreenToggleButton,
    MRT_ToggleFiltersButton
} from 'material-react-table';

//import { Box, IconButton, Tooltip/*, EditIcon,DeleteIcon*/, MenuItem, TextField, ListItemText } from '@mui/material';


import { MRT_Localization_FR } from 'material-react-table/locales/fr';
import i18n from 'i18next';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ClearIcon from '@mui/icons-material/Clear';
import debounce from 'lodash.debounce';
import "@progress/kendo-theme-material/dist/all.css";
import { Grid, GridColumn, GridColumnMenuWrapper } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";

import {
    Filter,
    Operators,
    TextFilter,
    NumericFilter,
    BooleanFilter,
} from "@progress/kendo-react-data-tools";
import { filterBy } from "@progress/kendo-data-query";
import {
    EnumFilter,
    GridColumnMenuFilter,
    GridColumnMenuCheckboxFilter,
} from "@progress/kendo-react-grid";
import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
} from "@progress/kendo-react-intl";
import * as ReactDOM from "react-dom/client";

import '@popperjs/core';

import Tooltip from '@mui/material/Tooltip';
import { Instance } from '@popperjs/core';


import { CustomFilterUI } from "./datefilter";
import frMessages from "./fr-FR.json";
loadMessages(frMessages, "fr");





const ManagementTable = React.forwardRef((props, ref) => {

    class DateRangeFilter extends React.Component {
        render() {
            return (
                <div className="k-filtercell">
                    <DatePicker
                        value={this.props.min}
                        onChange={(e) => {
                            this.props.onDateFilterChange({
                                value: e.target.value,
                                operator: "gt",
                            });
                        }}
                    />
                    <DatePicker
                        value={this.props.max}
                        onChange={(e) => {
                            this.props.onDateFilterChange({
                                value: e.target.value,
                                operator: "lt",
                            });
                        }}
                    />
                    <button
                        className="k-button k-button-icon k-clear-button-visible"
                        title="Clear"
                        disabled={!(this.props.min || this.props.max)}
                        onClick={() => this.props.onDateFilterClear()}
                    >
                        <span className="k-icon k-i-filter-clear" />
                    </button>
                </div>
            );
        }
    }

    const language = 'fr';

    const messagesObj = {
        "grid.pagerItemPerPage":"asdjalksdjsalkdjlas"
    }
    


    const { t, i18n } = useTranslation();
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const paginatorRef = useRef(null);
    const searchRef = useRef(null);
    const [activePage, setActivePage] = useState(0);
    const [modalSettings, setModalSettings] = useState({});

    
    const [isLoading, setIsLoading] = useState(false);
    const [sorting, setSorting] = useState([]);
    const [columnSizing, setColumnSizing] = useState({});
    const [columnFilters, setColumnFilters] = useState([]);

    const [configLoaded, setConfigLoaded] = useState(false);
    const [pageOptions, setPageOptions] = useState(null);

    const [allValues, setAllValues] = useState({
        initialized: false,
        loaded:false,
        sizing: {},
        columnFilters: [],
        sorting: []
    });

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: props.pageSize, //customize the default page size
    });


    
    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }
    const previousFilter = usePrevious(columnFilters);



    let navigate = useNavigate();

    useImperativeHandle(ref, () => ({
        resetPage() {      
            refresh();           
        }
    }));


    // Event listener called on every change
    const onChange = (header, e) => {
        //console.log(e.target.value)
        header.column.setFilterValue(e.target.value || undefined);
    }

  
    const addAllOption = (array) => {
        var options = array;
        options?.unshift({ value: "", text: t("all") })
        return [...new Map(options?.map(item => [item["value"], item])).values()];

        //return options;
    }
    const getNewCols = () => {
        var c = props.columns?.map(x => {
            return {

                filterVariant: x.filterSelectOptions ? "select" : "text",
                filterSelectOptions: x.filterSelectOptions ?? null,
                size: x.size ?? null,
                accessorKey: x.prop ? x.prop : x.name,
                header: t(x.name),
                id: x.prop ? x.prop : x.name,
                accessorFn: x?.fn ? (row, col) => x.fn?.(row[x.prop || x.name]) : null /*, sort: x.sort ?? false*/,
               } });
        //console.log(c)
        return c;
    }

   

    useEffect(() => {
        
      
        if (isInitialized()) {
            //console.log("columnFilters accepted");
            setAllValues({ ...allValues, ["columnFilters"]: columnFilters });
            //setFilter(columnFilters)

            props?.onFiltersChange?.(columnFilters);


            if (pagination.pageIndex == 0) {
                //ROLLBACK setPageOptions({ page: pagination.pageIndex, filter: columnFilters, sort: toSimpleSort(allValues?.sorting) });                
            } else {
                setPagination({
                    pageIndex: 0,
                    pageSize: props.pageSize, //customize the default page size
                });
            }

        }

    }, [columnFilters]);

  
    useEffect(() => {        
        if (isInitialized()) {            
            setAllValues({ ...allValues, ["sizing"]: columnSizing });
            props?.onColumnSizeChange?.(columnSizing);
        }
    }, [columnSizing]);

    useEffect(() => {        
        if (isInitialized()) {            
            setAllValues({ ...allValues, ["sorting"]: sorting });
            props?.onSortingChange?.(sorting);
        }

    }, [sorting]);

    const toSimpleSort = (sorting) => {
        var sort = sorting?.length ? sorting[0] : null; //Use first sort, not multiple        
        return sort ? `${sort.id} ${sort.desc ? 'desc' : 'asc'}` : "";
    }

    const isInitialized = () => (allValues?.initialized ?? false) && (allValues?.loaded ?? false);

    useEffect(() => {        
        if (allValues?.initialized && !allValues?.loaded) { //First load           
            setAllValues({ ...allValues, ["loaded"]: true });
        }
    }, [allValues])

   

    useEffect(() => {

        //Initial load
        if (!configLoaded) {

            if (props.config.dataState)
                setDataState(props.config.dataState);
            else
                setDataState({ take: 10, skip: 0 });
          
            setAllValues({ initialized: true, sizing: props.config?.size ?? {}, columnFilters: props.config?.filter ?? [], sorting: props.config?.sort ?? [] })        
            setConfigLoaded(true);            
        }
    }, [props.config]);

    useEffect(() => {        
    }, [pagination.pageIndex, pagination.pageSize,pagination.refreshed]);

    useEffect(() => {
        setIsLoading(props.isLoading);
    }, [props.isLoading]);

    const onDataStateChange = (e) => {
        
        setDataState(e.dataState);        
    }

    const [dataState, setDataState] = React.useState({
        take: 10,
        skip: 0,
    });

   
    const refresh = () => {
        if (dataState && configLoaded)
            props.onPageChange?.({ take: dataState.take, skip: dataState.skip, sortBy: dataState.sort, filterBy: dataState.filter });
    }

    useEffect(() => {
        if (dataState) {
            props.onDataStateChange?.(dataState);
            if (configLoaded)
                props.onPageChange({ take: dataState.take, skip: dataState.skip, sortBy: dataState.sort, filterBy: dataState.filter });
        }

    }, [dataState]);

    const handleExpandChange = (nextExpandState) => {        
        // check first with some custom function if the language is not English 
        setTimeout(() => { // wait a while to allow render
            // get all labels
            const labels = document.querySelectorAll('.k-checkbox-label');
            // take all except the first which is 'select all'
            // and is usually already translated by Kendo component
            const [, ...rest] = labels;
            rest.forEach((filter, index) => {                
                rest[index].textContent = t(rest[index].textContent);                
            });
        }, 0);
    };

    const handleExpandMenu = (nextExpandState) => {
        // check first with some custom function if the language is not English 
        setTimeout(() => { // wait a while to allow render
            // get all labels
            const labels = document.querySelectorAll('input.k-input-inner');
            // take all except the first which is 'select all'
            // and is usually already translated by Kendo component
            

            const [, ...rest] = labels;
            rest.forEach((filter, index) => {
                //rest[index].textContent = t(rest[index].textContent);
                //console.log(filter)
            });
        }, 0);
    };

    const fieldOptions = (field) => props.columns?.find(c => field == (c.prop ? c.prop : c.name))?.filterSelectOptions;

    const displayFilter = (filter) => {       
        var text = "";

        text += filter?.filters ? filter?.filters?.map(x => {
            var t = "";
            if (x.filters)
                t += displayFilter(x);
            else {                
                t += ` ('${i18n.t(x.field)}' <u>${i18n.t(x.operator)}</u>`;
                if (["isnull", "isnotnull", "isempty", "isnotempty"].indexOf(x.operator) == -1)
                    t += ` '${fieldOptions(x.field) ? i18n.t(x.value) : x.value}')`;
            }
            return t;
        }).join(` <b>${filter.logic.toUpperCase()}</b>`) : "";

        return text;
    }

    const getFilterColumn = (col, props) => {        
        if (col.filterSelectOptions) {
            var field = col.prop ? col.prop : col.name;
            var items = col.filterSelectOptions?.map(x => { return { [field]: x.text } });
            return <GridColumnMenuCheckboxFilter {...props} data={items} onExpandChange={handleExpandChange} />;
        } else
            return <GridColumnMenuFilter {...props} /*onExpandChange={handleExpandMenu}*/ filterUI={col.type=="month"?CustomFilterUI:null}  />

    }
    const positionRef = React.useRef(null);
    const popperRef = React.useRef(null);    
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const handleMouseMove = (event) => {        
        var isHeader = event.target.matches("span.k-column-title");
        positionRef.current = isHeader ? { x: event.clientX, y: event.clientY, title: event.target.textContent } : { x: -100, y: -100, title: "" };
        setTooltipVisible(isHeader);
        
        if (popperRef.current != null) {
            popperRef.current.update();
        }
    };

    
    return (        

        <Tooltip            
            open={tooltipVisible}
            title={positionRef.current?.title}
            placement="top"
            arrow
            PopperProps={{
                popperRef,
                anchorEl: {
                    getBoundingClientRect: () => {
                        return  new DOMRect(
                            positionRef?.current?.x,
                            positionRef?.current?.y,
                            0,
                            0,
                        );
                    },
                },
            }}>

            <Card onMouseMove={handleMouseMove}> 
                
            <Card.Body>
              
                <ConfirmPopup show={show} isDeleting={modalSettings?.isDeleting || false} onClose={handleClose} title={modalSettings?.title} body={modalSettings?.body} onClick={modalSettings.onConfirm} />
                <Stack gap={2}>
                    
                    {!props.hideHeader && <Row className="mb-3">
                        <div className="flex-d">
                            <b>{t('administration')}: {props.name}</b>
                            <div className="float-end" style={{ display: props.new?.hidden ? "none" : "" }}>
                                <Stack direction="horizontal" gap={2}>
                                    {props.actions?.map((b, i) => (
                                        <button key={i} className="btn btn-secondary" onClick={() => { b?.onClick?.() }}>
                                            <FontAwesomeIcon icon={b.icon} />&nbsp;
                                            {t(b.text)}
                                        </button>
                                    )
                                    )}

                                {props?.isLoading ? <Skeleton height={35} width={100} /> : <button className="btn btn-secondary" onClick={() => {
                                    props.new ? props.new?.onClick?.() : navigate(`./new`);
                                }}>{t(props.new ? props.new?.title:'createNew')}
                                    </button>}
                                
                            </Stack>

                            </div>
                        </div>
                    </Row>}
                  
                </Stack>
                

            
                <div style={{ paddingBottom:6 }} dangerouslySetInnerHTML={{ __html: displayFilter(dataState.filter,props.columns) ? `${t("filterQuery")}: ${displayFilter(dataState.filter)}` : "" }} />
                <LocalizationProvider language={i18n.language}>

                    
                <Grid
                    onColumnResize={(e) => {                        
                        props.onColumnSizeChange?.(e.columns.map(x => Number(x.width)));
                    }}
                    size="small"
                    {...dataState}
                    data={props.items}
                    total={props.total}
                    sortable={true}                    
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [5, 10, 15,25,50, 100, 200],                        
                    }}
                    
                    resizable={true}
                    onDataStateChange={onDataStateChange}
                >                   
                        {props.columns?.map((x, i) => (
                            <GridColumn format={x.filter == "date" ? "{0:MM/yyyy}" : null}
                                minResizableWidth={75}
                                columnMenu={(props) => getFilterColumn(x, props)}
                                filter={x.filter ?? null}
                                width={props?.config?.size?.[i] ?? undefined}
                                key={i}
                                id={x.prop ? x.prop : x.name}
                                field={x.prop ? x.prop : x.name}
                                title={t(x.name)}                            
                                cell={(p) => {
                                    var val = x.fn ? (x.fn?.(p.dataItem[x.prop || x.name])) : p.dataItem[x.prop || x.name]
                                    return <td title={val} style={{ fontSize: '0.75rem' }}>
                                        <span style={{ wordWrap: "initial", whiteSpace: props.wrapWholeRow ? "nowrap" : "initial" }}>
                                            {x.useFormat ? <NumberFormatted decimals={isNaN(parseInt(x.useFormat?.decimals)) ? 2 : x.useFormat?.decimals}  number={p.dataItem[x.prop || x.name]} fn={x.fn} /> :  val }
                                        </span>
                                    </td>
                                }}
                            />
                    ))}

                        <GridColumn
                            resizable={true}
                            filterable={false}
                            sortable={false}                            
                            minResizableWidth={130}
                            headerCell={(headerProps) => <div style={{ fontSize: '0.70rem', textAlign: "right", width: "100%" }}>{t("actions")}</div>}
                            title={t("actions")}
                            cell={(cellProps) =>
                                <td >
                                    <Stack direction="horizontal" gap={1} className="text-right">
                                        <span className="me-auto" />
                                        {props.extraButtons?.map((b, i) => (

                                            /*<Tooltip key={i} title={b.text} arrow placement="right" enterDelay={200} leaveDelay={100}>*/
                                            <span title={b.text} key={i}>
                                    <Button  style={{paddingTop: 2,paddingBottom:2,paddingLeft:10,paddingRight:10 }} variant={b?.danger ? "outline-primary" : "outline-secondary"} onClick={
                                        () => {
                                            if (b.modalText) {
                                                setModalSettings({
                                                    isDeleting: b?.danger ?? false,
                                                    title: b?.modalTitle,
                                                    body: b?.modalText,
                                                    onConfirm: () => b?.onClick?.(cellProps.dataItem?.id)
                                                });
                                                handleShow();
                                            } else {
                                                b.onClick?.(cellProps.dataItem?.id);
                                            }
                                        }
                                    }>

                                        <FontAwesomeIcon icon={b.icon} />
                                    </Button>
                                </span>

                                        ))}
                                    </Stack>
                                </td>

                            } />
                        </Grid>

                    
                </LocalizationProvider>
                </Card.Body>
            
            </Card>
        </Tooltip>
    );
});

export default observer(ManagementTable);
